import { createFileRoute, notFound } from "@tanstack/react-router";
import { getTutorial } from "@/lib/tutorials-data";
import { ArticlePage } from "@/components/article-page";
import { articleHead } from "@/lib/article-seo";
import { NotFoundPage } from "@/components/not-found-page";
import type { Article } from "@/lib/content-blocks";

export const Route = createFileRoute("/tutorials/$slug")({
  head: ({ params }) =>
    articleHead({
      item: getTutorial(params.slug),
      slug: params.slug,
      base: "/tutorials",
      areaName: "Tutorials",
      noun: "Tutorial",
      schema: "howto",
    }),
  loader: ({ params }) => {
    const item = getTutorial(params.slug);
    if (!item) throw notFound();
    return { item };
  },
  component: TutorialRoute,
  notFoundComponent: () => <NotFoundPage />,
  errorComponent: ({ error }) => (
    <div className="py-12">
      <h1 className="text-2xl font-semibold mb-2">Something went wrong</h1>
      <p className="text-muted-foreground mb-6">{error.message}</p>
    </div>
  ),
});

function TutorialRoute() {
  const { item } = Route.useLoaderData() as { item: Article };
  return <ArticlePage item={item} />;
}
